import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

import type { InputProps } from "../answers";

import { optionSx } from "./optionSx";

export const BooleanInput: React.FC<InputProps<"boolean">> = ({ answer, onChange }) => {
    const { formatMessage } = useIntl();
    return (
        <RadioGroup
            row
            value={answer?.value ?? ""}
            onChange={(event) => onChange({ ...answer, value: event.target.value })}
            sx={{ gap: 1 }}
        >
            <FormControlLabel
                sx={{ ...optionSx, width: "auto", minWidth: 140 }}
                value="yes"
                control={<Radio />}
                label={formatMessage({ defaultMessage: "Yes" })}
            />
            <FormControlLabel
                sx={{ ...optionSx, width: "auto", minWidth: 140 }}
                value="no"
                control={<Radio />}
                label={formatMessage({ defaultMessage: "No" })}
            />
        </RadioGroup>
    );
};
